module.exports = __webpack_public_path__ + "static/media/IMG--146_websize.fa579bf6.jpg";